import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleFieldGetService } from '../../services';

export const fetchModuleFieldGet = createAsyncThunk(
    'moduleFieldGet/fetchModuleFieldGet',
    async ({ id }) => {
        const response = await ModuleFieldGetService(id)
        return response.result;
    }
);

const moduleFieldGetSlice = createSlice({
    name: 'moduleFieldGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleFieldGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleFieldGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleFieldGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleFieldGetSlice.reducer;
